/*--------------------------------------
 SORT BY
 --------------------------------------*/
 sortBy = {
    init: function () {

        $(".filter__filtering__title").on("click", function(){
            $(".filter__sortby").removeClass("open");
            $(this).closest(".filter__filtering").toggleClass("open");
        });
    
        $(".filter__sortby__title").on("click", function(){
            $(".filter__filtering").removeClass("open");
            $(this).closest(".filter__sortby").toggleClass("open");
        });

        $("body").on("click", function(e){
            if (!$(e.target).closest('.filter__filtering__title, .filter-facets--wrapper, .filter__sortby__title, .filter__sortby__options').length) {
                $(".filter__filtering").removeClass("open");
                $(".filter__sortby").removeClass("open");
            }
        });



        // Save existing sort parameters
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }

        // Add existing sort parameters to current URL
        document.querySelector('.sort-by').addEventListener('change', function (e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }
};

$(document).ready(function () {
    sortBy.init();
});
$(document).on('shopify:section:load', function (event) {
    sortBy.init();
});